import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";

export const useBusinessCategories = (businessId, options = {}) => {
  return useQuery({
    queryKey: ["business-categories-v2", businessId],
    enabled: Boolean(businessId) && options.enabled !== false,
    queryFn: async () => {
      if (!businessId) {
        return [];
      }

      const response = await apiClient.get(`/business/${businessId}`, {
        params: {
          version: "v2",
          params: "id,categories,name",
          mode: "dashboard",
        },
      });

      return response?.result?.categories || [];
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    ...options,
  });
};

export const useBusinessProducts = (businessId, options = {}) => {
  const { enabled = true, apiParams = {}, ...queryOptions } = options;
  const serializedApiParams = JSON.stringify(apiParams || {});

  return useQuery({
    queryKey: ["business-products-v2", businessId, serializedApiParams],
    enabled: Boolean(businessId) && enabled !== false,
    queryFn: async () => {
      if (!businessId) {
        return [];
      }

      const response = await apiClient.get(`/business/${businessId}/products`, {
        params: {
          version: "v2",
          params: "name,id,enabled,category_id",
          mode: "dashboard",
          ...apiParams,
        },
      });
      const products = response?.result?.products;
      if (Array.isArray(products)) {
        return products;
      }
      if (Array.isArray(response?.result)) {
        return response.result;
      }
      return [];
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    ...queryOptions,
  });
};
